// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Core from '@/until/core'
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(Vuex)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
const store = new Vuex.Store({
    state: {
        appMessage: '',
        appLoaderShow: null,
        sourceRoute: null,
        scrollBottom: 0,
        routerParams: {
            Uid: 0,
            ShareCode: 0
        },
        staffData: null
    },
    mutations: {
        onChangeAppMessage (state, value) {
            state.appMessage = value
        },
        onChangeSourceRoute (state, value) {
            state.sourceRoute = value
        },
        onChangeAppLoaderShow (state, value) {
            state.appLoaderShow = value
        },
        onChangeRouterParams (state, value) {
            state.routerParams = value
        },
        onChangeScrollBottom (state, value) {
            state.scrollBottom = value
        },
        onChangeStaffData (state, value) {
            state.staffData = value
        },
        onChangeRouterParamsPush (state, value) {
            if (_.isPlainObject(value)) {
                state.routerParams = Object.assign(state.routerParams, value)
            }
        }
    }
})

const filterRouter = ['mobileenroll', 'stafflogin']
const remRouter = []
router.beforeEach((route, redirect, next) => {
    // 进入页面前
    // console.log('beforeEach', route, redirect)
    store.commit('onChangeAppLoaderShow', '玩命加载中, 请稍候...')
    const authUrl = Core.setAuthUrl(null, false)
    if (!authUrl) {
        const url = window.location.href.split('#')[0]
        Core.setAuthUrl(url, true)
    }
    Core.use('router', { route: route, redirect: redirect })
    if (remRouter.indexOf((route.name).toLowerCase()) === -1) {
        Core.stopHistory(route.fullPath)
    }
    Core.on('error', (error) => {
        // 错误展示页面
        return router.push({name: 'ErrorMessage', params: route.params, query: {message: error, source: route.fullPath}})
    })
    if (filterRouter.indexOf((route.name).toLowerCase()) >= 0) {
        // 过滤掉授权验证, 直接进入页面
        if (remRouter.indexOf((route.name).toLowerCase()) >= 0) {
            Core.setRem()
        }
        return Core.continued(next)
    } else if ((route.name).toLowerCase().indexOf('error') === 0) {
        // 进入错误页面
        return Core.error(next)
    } else if (!parseInt(route.params.Uid, 10)) {
        // 没有找到 uid 参数, 直接进入错误页面 把错误来源 route.fullPath 添加到参数中
        return router.push({name: 'ErrorMessage', params: route.params, query: {message: 'no_available_ports_were_found', source: route.fullPath}})
    }
    localStorage.setItem('cacheSourceRoute', redirect.fullPath)
    Core.ready(next)
})
router.afterEach((route) => {
    // 进入页面后
    // console.log('to', route)
    const Options = Core.getOptions()
    window.document.title = Options.WEB_APP_TITLE || '\u200E' // 设置标题为空
    store.commit('onChangeAppLoaderShow', false)
    store.commit('onChangeScrollBottom', '0')
    store.commit('onChangeRouterParams', route.params)
    store.commit('onChangeSourceRoute', localStorage.getItem('cacheSourceRoute') || null)
    localStorage.removeItem('cacheSourceRoute')
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>',
    mounted () {}
})



// WEBPACK FOOTER //
// ./src/main.js